@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@s-ui/theme/lib/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@adv-mt/mt-layout-basic/lib/index';

@import '~@s-ui/react-molecule-notification/lib/index';
@import '~@adv-mt/mt-panel-basic/lib/index';
@import '~@adv-mt/mt-svg-icons/lib/index';
@import '~@adv-mt/mt-title-basic/lib/index';

@import '../components/FormUserAvatar/index.scss';
@import '../components/FormUserModifyPassword/index.scss';
@import '../components/FormUserPersonalData/index.scss';

.mt-userProfileEdit {
  padding: $p-m;

  &-title {
    margin-bottom: $m-xl;
  }
}
